// Mutual exclusion groups for the Opal web funnel.
//
// Experiments in the same group will never overlap (a user assigned to one
// experiment in the group is excluded from the others). Set the group via
// `mutualExclusionGroup: '<key>'` on a defineExperiment() call.
//
// Adding/removing a group is a structural change: PR + sync. The sync script
// creates missing groups; it never deletes them (deletion is manual in the
// Amplitude UI, with the file removed in a follow-up PR).

import { defineMutualExclusionGroup } from '../src/lib/experiments/define';

export const welcome = defineMutualExclusionGroup({
  key: 'welcome',
  name: 'Welcome screen surface',
  description: 'Experiments on the funnel landing/welcome screen.',
});

export const paywall = defineMutualExclusionGroup({
  key: 'paywall',
  name: 'Paywall surface',
  description: 'Experiments on the RC Web Billing paywall screens.',
});

export const pricing = defineMutualExclusionGroup({
  key: 'pricing',
  name: 'Pricing logic',
  description: 'Experiments on offering selection, pricing display, and discount logic.',
});

export const global = defineMutualExclusionGroup({
  key: 'global',
  name: 'Global / cross-surface',
  description: 'Experiments that touch multiple funnel surfaces or are not surface-bound.',
});

// Aggregate export consumed by the sync script + runtime registry.
export const ALL_GROUPS = [welcome, paywall, pricing, global] as const;
